import React from "react";

const StatusBadge = ({ status, actualBillid }) => {
  let primaryColor = "";
  let secondaryColor = "";
  let statusText = "";
  switch (status?.toLowerCase()) {
    case "created":
      primaryColor = "#1191DB";
      secondaryColor = "#E7F5FD";
      statusText = "Submitted";
      break;
    case "pending":
      primaryColor = "#DBAC11";
      secondaryColor = "#FDF2E7";
      statusText = "Pending for approval";
      break;
    case "modify":
      primaryColor = "#DBAC11";
      secondaryColor = "#FDF2E7";
      statusText = "Ask for modification";
      break;
    case "approved":
      primaryColor = "#3EB867";
      secondaryColor = "#EAFFF1";
      statusText = "Approved";
      break;
    case "rejected":
      primaryColor = "#AB0000";
      secondaryColor = "#FFEAEA";
      statusText = "Rejected";
      break;
    case "paid":
      primaryColor = "#3EB867";
      secondaryColor = "#EAFFF1";
      statusText = "Paid";
      break;
    case "partially paid":
      primaryColor = "#DBAC11";
      secondaryColor = "#FDF2E7";
      statusText = "Partially Paid";
      break;
    default:
      primaryColor = "#DBAC11";
      secondaryColor = "#FDF2E7";
      statusText = status;
      break;
  }

  if (status?.toLowerCase() == "modify" && actualBillid) {
    statusText = "Pending for approval";
  }
  return (
    <>
      {statusText && (
        <div
          style={{
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "16px",
            color: primaryColor,
            height: "24px",
            borderRadius: "40px",
            backgroundColor: secondaryColor,
            padding: "4px 8px",
            whiteSpace: 'nowrap',
          }}
        >
          {statusText}
        </div>
      )}
    </>
  );
};

export default StatusBadge;
